import { render, staticRenderFns } from "./ListAuto.vue?vue&type=template&id=65a2665e"
import script from "./ListAuto.vue?vue&type=script&lang=js"
export * from "./ListAuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports